module.exports = __webpack_public_path__ + "static/media/1.eb167575.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/products/images/4056/1.jpg
// module id = 673
// module chunks = 0